import { useMemo, useState } from 'react';
import { formatTextInfoSimpleFunc } from '../utils/chart';
import type { LangType } from '../components/FilterCommon/types';
import { topicEnMap, topicZhMap } from '../constants';
import { useFilterCondConf } from './useFilterCondConf';

/**
 * 有两处位置处理topic缓存数据
 * @param lang
 * @returns
 */
export default function useTranslateTopic(lang?: LangType) {
  const [translateTopic, setTranslateTopic] = useState<{
    [key: string]: { 'en-US': string; 'zh-CN': string };
  }>({});

  function setTranslateTopicMap(topic_trans: Array<any> = []) {
    let topicMap: {
      [key: string]: { 'en-US': string; 'zh-CN': string };
    } = {};
    topic_trans?.forEach(
      ({ L1_topic, L1_topic_transl, topic_to_en, trans }) => {
        let key = (L1_topic as string).toLocaleLowerCase();
        if (!topicMap[key]) {
          topicMap[key] = {
            'en-US': topicEnMap[key] || L1_topic,
            'zh-CN': topicZhMap[key] || L1_topic_transl,
          };
        }
        let key1 = (topic_to_en as string).toLocaleLowerCase();
        if (!topicMap[key1]) {
          topicMap[key1] = {
            'en-US': topicEnMap[key1] || topic_to_en,
            'zh-CN': topicZhMap[key1] || trans,
          };
        }
      },
    );

    setTranslateTopic(topicMap);
  }

  const translateTopicFunc = useMemo(() => {
    if (!lang) {
      return (value: string) => {
        console.error('hooks,没有设置语言');
        return value;
      };
    }
    const func = formatTextInfoSimpleFunc(translateTopic, lang);
    return (value: string) => {
      const key = value?.toLocaleLowerCase();
      return func(key);
    };
  }, [lang, translateTopic]);

  return { setTranslateTopicMap, translateTopic, translateTopicFunc };
}

export function useGetTopicFilter({
  gameInfo,
  needRequest = true,
}: {
  gameInfo: any;
  needRequest?: boolean;
}) {
  const { changeValue, ...topicList } = useFilterCondConf({
    needRequest,
    gameInfo,
    requestList: [
      { key: 'topic_trans', defaultValue: [] },
      { key: 'key_topic', defaultValue: {} },
    ],
  });

  return {
    topicList,
    changeTopicList: changeValue,
  };
}
